@if (app.elements.length > 0) {
  <div class="card m-1 p-1">
    <div>
      @for (element of app.elements; track element) {
        <button
          class="btn"
          [ngClass]="{ selected: element === app.element }"
          (click)="app.element = element"
          [ngbTooltip]="element"
          >
          {{ element }}
        </button>
      }
    </div>
    @if (app.element != null) {
      <div>
        <div class="controls">
          @if (app.types.indexOf(app.element) !== -1) {
            <button
              class="btn"
              (click)="app.type = app.element; app.routing.navigateExportData()"
              title="Docs"
              >
              {{ app.getTypeText(app.element) }}
              <!-- <span
              *ngIf="app.docs.countDocs(app.element) > 0"
              class="badge selected"
              >{{ app.docs.countDocs(app.element) }}</span -->
              >
            </button>
          }
        </div>
      </div>
    }
  </div>
}

@if (app.element != null) {
  <div>
    @if (app.getSettings('permission').length > 0) {
      <div class="card m-1 p-1">
        <h2>{{ app.text.settings.permissions }}</h2>
        <div>
          @for (permission of app.getSettings('permission'); track permission) {
            <button
              class="btn"
              [ngbTooltip]="app.element + '.' + permission"
              >
              {{ permission }}
            </button>
          }
        </div>
      </div>
    }
    @if (app.getSettings('text').length > 0) {
      <div class="card m-1 p-1">
        <h2>{{ app.text.settings.text }}</h2>
        <div>
          @for (text of app.getSettings('text'); track text) {
            <button
              class="btn"
              [ngbTooltip]="app.element + '.' + text"
              >
              {{ app.getText(app.element + "." + text) }}
            </button>
          }
        </div>
      </div>
    }
    @if (app.getSettings('list').length > 0) {
      <div class="card m-1 p-1">
        <h2>{{ app.text.settings.lists }}</h2>
        @for (list of app.getSettings('list'); track list) {
          <div class="m-1 p-1">
            <b>{{ list }}</b>
            <div>
              @for (
                item of app.getList(app.element + '.' + list); track
                item; let index = $index) {
                <button
                  class="btn btn-sm"
                  [ngbTooltip]="index + 1"
                  >
                  {{ item }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (app.getSettings('url').length > 0) {
      <div class="card m-1 p-1">
        <h2>{{ app.text.settings.urls }}</h2>
        @for (entry of app.getSettings('url'); track entry) {
          <div class="m-1 p-1">
            <b>{{ entry }}</b
              >:
              <a [href]="app.url[app.element][entry]" target="_blank">{{
                app.url[app.element][entry]
              }}</a>
            </div>
          }
        </div>
      }
    </div>
  }
